/*       */

import { gql } from '@apollo/client';

export default gql`
    query entitiesTreeListQuery($startIndex: Int, $stopIndex: Int, $type: String!, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        records: entities(type: $type, startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
            image
            iconName
            iconColor
            iconType
            type
            active
            primaryClass {
                entityTabs
            }
        }
    }
`;
